import { apiClient } from '../config'

import type { PipelineSlaResponse } from '../types'

export const pipelineSlaService = {
  getDashboard: async (): Promise<PipelineSlaResponse> => {
    const response = await apiClient.get<PipelineSlaResponse>('/admin/pipeline-sla')
    return response.data
  },
}
